import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TrCheckboxComponent } from './tr-checkbox.component';

@NgModule({
    imports: [
        CommonModule,
        MatCheckboxModule,
    ],
    exports: [ TrCheckboxComponent ],
    declarations: [ TrCheckboxComponent ],
})
export class TrCheckboxModule {}
